'use strict';

angular.module('esn.calendar')
  .component('calCreateCalendarMenuItem', {
    template: require('./create-calendar-menu-item.pug')
  });
